import * as Sentry from "@sentry/react"
import type { Router } from "@tanstack/react-router"
import { env } from "./env"
import type { routeTree } from "./route-tree.gen"

/**
 * @todo add more integrations e.g. replay or browser tracing
 */
export default function initSentry(
	router:
		| Router<typeof routeTree>
		| Parameters<typeof Sentry.tanstackRouterBrowserTracingIntegration>[0],
) {
	// Avoid TS error by casting router to the required type
	// FIXME: find how to handle this without casting
	const browserTracingIntegration =
		Sentry.tanstackRouterBrowserTracingIntegration(
			router as Parameters<
				typeof Sentry.tanstackRouterBrowserTracingIntegration
			>[0],
		)

	return Sentry.init({
		dsn: env.VITE_SENTRY_DSN,
		environment: env.VITE_SENTRY_ENV,
		tracesSampleRate: env.VITE_SENTRY_TRACE_SAMPLE_RATE,

		integrations: [browserTracingIntegration],
	})
}
